module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 99
// module chunks = 14